import {
  AutoClearCooldownFromFeedOutdoorActivityType,
  AutoClearCooldownFromInvestigateOutdoorActivityType,
  EscalateToIntrusionWithDescriptionOutdoorActivityType,
  FamiliarFaceReviewWithoutAIOutdoorActivityType,
  FinalDocumentationOutdoorActivityType,
  MonitoringSpecialistAssignmentOutdoorActivityType,
  MonitoringSpecialistTriageOutdoorActivityType,
  QuickClearFromInvestigateOutdoorActivityType,
  RecentHistoryOutdoorActivityType,
  TwoWayAudioCheckpointOutdoorActivityType,
  TwoWayAudioInteractionOutdoorActivityType
} from '../../../api/models'

export const UNKNOWN_STATE = 'Unknown'

export enum ModeType {
  QA = 'Quality',
  Inspect = 'Inspect',
  CustomerCare = 'Care'
}

// Priority order used when a user isn't authorized for the requested mode and needs to fall back to one they are.
export const ALL_MODES: ModeType[] = [ModeType.QA, ModeType.Inspect, ModeType.CustomerCare]

export enum FormType {
  NO_2WA = 'No 2WA',
  TWO_WAY_AUDIO = '2WA',
  QUICK_CLEAR = 'Quick Clear'
}

export const FormURLMap: Record<FormType, string> = {
  [FormType.NO_2WA]: 'https://docs.google.com/forms/d/e/1FAIpQLSduMdUMy2PtGyBrhkqAcCDgWSy-T9ltX0bNdlOA22QI8rQByQ/viewform',
  [FormType.TWO_WAY_AUDIO]: 'https://docs.google.com/forms/d/e/1FAIpQLSeoB6IGSNR-7Ax4X4VP_uOOTTP6CHapGbZbaA4BeSx4q-QP0w/viewform',
  [FormType.QUICK_CLEAR]: 'https://docs.google.com/forms/d/e/1FAIpQLSffoLPoQSq8HoLznwg4Wm0luKJGPsiG4m3Ai25LLkkMQDaVAQ/viewform'
}

export const CUSTOMER_CARE_GOOGLE_FORM_URL = 'https://docs.google.com/forms/d/e/1FAIpQLSeh2NXG-BI0spHRkuyq1Dhd2LnGlzVojT_l924eQRQHpfSOcA/viewform'

export const ActivityType = {
  MonitoringSpecialistAssignmentOutdoorActivityType: MonitoringSpecialistAssignmentOutdoorActivityType.MonitoringSpecialistAssignment,
  MonitoringSpecialistTriageOutdoorActivityType: MonitoringSpecialistTriageOutdoorActivityType.MonitoringSpecialistTriage,
  AutoClearCooldownFromFeedOutdoorActivityType: AutoClearCooldownFromFeedOutdoorActivityType.AutoClearCooldownFromFeed,
  AutoClearCooldownFromInvestigateOutdoorActivityType: AutoClearCooldownFromInvestigateOutdoorActivityType.AutoClearCooldownFromInvestigate,
  QuickClearFromInvestigateOutdoorActivityType: QuickClearFromInvestigateOutdoorActivityType.QuickClearFromInvestigate,
  EscalateToIntrusionWithDescriptionOutdoorActivityType: EscalateToIntrusionWithDescriptionOutdoorActivityType.EscalateToIntrusionWithDescription,
  RecentHistoryOutdoorActivityType: RecentHistoryOutdoorActivityType.RecentHistory,
  TwoWayAudioCheckpointOutdoorActivityType: TwoWayAudioCheckpointOutdoorActivityType.TwoWayAudioCheckpoint,
  FamiliarFaceReviewWithoutAIOutdoorActivityType: FamiliarFaceReviewWithoutAIOutdoorActivityType.FamiliarFaceReviewWithoutAI,
  TwoWayAudioInteractionOutdoorActivityType: TwoWayAudioInteractionOutdoorActivityType.TwoWayAudioInteraction,
  FinalDocumentationOutdoorActivityType: FinalDocumentationOutdoorActivityType.FinalDocumentation
} as const

export type ActivityType = (typeof ActivityType)[keyof typeof ActivityType]

export const ActivityTypeDisplayNames: Record<ActivityType, string> = {
  [ActivityType.MonitoringSpecialistAssignmentOutdoorActivityType]: 'Engagement Assigned',
  [ActivityType.MonitoringSpecialistTriageOutdoorActivityType]: 'Monitoring Specialist Triage',
  [ActivityType.AutoClearCooldownFromFeedOutdoorActivityType]: 'Auto Clear Cooldown from Feed',
  [ActivityType.AutoClearCooldownFromInvestigateOutdoorActivityType]: 'Auto Clear Cooldown from Investigate',
  [ActivityType.QuickClearFromInvestigateOutdoorActivityType]: 'Quick Clear From Investigate',
  [ActivityType.EscalateToIntrusionWithDescriptionOutdoorActivityType]: 'Escalation',
  [ActivityType.RecentHistoryOutdoorActivityType]: 'Recent History',
  [ActivityType.TwoWayAudioCheckpointOutdoorActivityType]: '2WA Checkpoint',
  [ActivityType.FamiliarFaceReviewWithoutAIOutdoorActivityType]: 'Familiar Face Assessment',
  [ActivityType.TwoWayAudioInteractionOutdoorActivityType]: '2WA Interaction',
  [ActivityType.FinalDocumentationOutdoorActivityType]: 'Final Documentation'
}

export enum AudioQuality {
  Good = 'Good',
  Fair = 'Fair',
  Poor = 'Poor',
  Unknown = 'Unknown'
}

export type ModeRouteHandle = { mode: ModeType }

export const isModeRouteHandle = (handle: unknown): handle is ModeRouteHandle =>
  typeof handle === 'object' &&
  handle !== null &&
  'mode' in handle &&
  Object.values(ModeType).includes((handle as { mode: unknown }).mode as ModeType)
